export const REGISTRATION_API_BASE_URL = process.env.REACT_APP_REGISTRATION_API_BASE_URL;
